import React from 'react';
import { formatSpan } from '../lib/datetime';
import { CarIcon } from './icons';

/** En delad träff som den ser ut inuti ett chattmeddelande. */
export default function MeetChip({ meet, onOpen }) {
  return (
    <button className="meet-chip" onClick={onOpen} type="button">
      <span className="meet-chip__icon"><CarIcon size={18} /></span>
      <span className="meet-chip__body">
        <span className="meet-chip__title">{meet.title}</span>
        <span className="meet-chip__line">{formatSpan(meet.event_date, meet.end_date)}</span>
        {meet.address && <span className="meet-chip__line">{meet.address}</span>}
      </span>
    </button>
  );
}
